import { useLocation } from 'react-router'
import { Tabs } from '@boltenergy-be/design-system'
import SubNavTabLink from 'components/subnav/SubNavTabLink.tsx'
import { SubNavProps } from 'components/subnav/types.ts'

const SubNav = ({ className, tabs, tabRefs, wrapperClassName }: SubNavProps) => {
  // Router
  const location = useLocation()

  return (
    <div className={wrapperClassName}>
      <Tabs
        {...{ tabs, className }}
        activeTabPath={location.pathname}
        renderTab={(tab, props) => <SubNavTabLink key={tab.path} tab={tab} anchorRef={tabRefs?.[tab.path]} {...props} />}
      />
    </div>
  )
}

export default SubNav
